import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['commandLineVisible'] = false,
  action: Action,
): RootState['commandLineVisible'] {
  switch (action.type) {
    case 'COMMAND_LINE_VISIBLE_SET': {
      return action.payload
    }

    default:
      return state
  }
}
